import React, { useEffect, useState } from "react";
import congrats from "../assets/images/congrats.svg";
import axios from "axios";
import { getTemplateData } from "../services/apiservice";
import toplogo from "../assets/images/tlogo.png";
import "../styles/feedback.css";
import Footer from "./Footer";
import Modal from "./Modal";
import { useNavigate, useSearchParams } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faFaceSmile as faSmile,
  faFaceFrown as faFrown,
  faFaceMeh as faMeh,
  faFaceGrinStars as faGrinStars,
} from "@fortawesome/free-regular-svg-icons";
import GradientHeader from "./GradientHeader";

export const FeedbackPage = () => {
  const [searchParams] = useSearchParams();
  const token = searchParams.get("token");
  const onelinkRequestId = searchParams.get("onelink_request_id");
  const navigate = useNavigate();
  const [feedback, setFeedback] = useState("");
  const [_, setCoupId] = useState();
  const [loading, setLoading] = useState(false);
  const [redirectToLinkedin, setRedirectToLinkedin] = useState(false);
  const [redemptionData, setRedemptionData] = useState({
    backroundColor: "",
    logoImageUrl: "",
    buttonColor: "",
    logoImage: "",
    footerColor: "",
    headerColor: "",
    footerText: "",
    customerId: null,
  });
  const [modalShown, setModalShown] = useState(false);
  const [selectedRating, setSelectedRating] = useState(null);
  const [customerId, setCustomerId] = useState(null);

  const ratings = [
    { value: "Average", icon: faFrown, label: "Average", emoji: "☹️" },
    { value: "Decent", icon: faMeh, label: "Decent", emoji: "😐" },
    { value: "Impressive", icon: faSmile, label: "Impressive", emoji: "😄" },
    { value: "Awesome", icon: faGrinStars, label: "Awesome", emoji: "😍" },
  ];

  useEffect(() => {
    if (token === null || token === "" || token === undefined) {
      window.location.href = "https://swageazy.com/";
      return;
    }
    getTemplateIdFromCoupon();
    getCouponItems();
  }, []);

  function openThankYouOrLinkedinPage() {
    if (
      customerId &&
      Number(customerId) === Number(process.env.REACT_APP_CUSTOMER_ID)
    ) {
      navigate(`/redemption/thank-you`);
    } else {
      if (redirectToLinkedin) {
        setTimeout(() => {
          window.location.href = "https://www.linkedin.com/company/swageazy";
        }, 2500);
      } else {
        navigate(`/redemption/thank-you`);
      }
    }
  }

  function getTemplateIdFromCoupon() {
    getTemplateData()
      .then((response) => {
        const data = response.data.result;
        setRedemptionData({
          backgroundColor:
            data.pageBackgroundColor || data.page_background_color,
          logoImageUrl: data.logo_image_url,
          buttonColor: data.buttonColor,
          logoImage: data.logo_image_url,
          footerColor: data.footer_color || "",
          headerColor: data.header_color || "",
          footerText: data.footer_text || "",
          customerId: data.customer_id ?? null,
        });
        setCoupId(data.id);
        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
      });
  }

  function getCustomerConfig() {
    setLoading(true);
    axios
      .get(
        `${process.env.REACT_APP_URL}/v5/customers/${customerId}/config/redemption`
      )
      .then((res) => {
        if (res.data.success && res.data.result) {
          setRedirectToLinkedin(
            Boolean(Number(res.data.result.redirect_redemptions_to_linkedin))
          );
        }
      })
      .catch((err) => {
        setLoading(false);
        navigate({
          pathname: "/",
        });
      });
  }

  function getCouponItems() {
    axios
      .get(
        `${process.env.REACT_APP_URL}/v4/customer/redemption/couponItems?token=${token}`
      )
      .then((res) => {
        if (res.data.success && res.data.result) {
          setCustomerId(res.data.result.customer_id);

          setRedirectToLinkedin(
            Boolean(
              Number(
                res.data.result.customer_config.redirect_redemptions_to_linkedin
              )
            )
          );
        }
      })
      .catch((err) => {
        console.error("Error fetching coupon items:", err);
      });
  }

  const handleSubmit = async () => {
    try {
      // Find the selected rating object to get the emoji
      const selectedRatingObj = ratings.find(
        (rating) => rating.value === selectedRating
      );
      const emoji = selectedRatingObj ? selectedRatingObj.emoji : "";

      const response = await axios.post(
        `${process.env.REACT_APP_URL}/v5/orders/users/coupon/${token}/feedback`,
        {
          rating: selectedRating,
          emoji: emoji,
          feedback_message: feedback,
          onelink_request_id: onelinkRequestId,
        }
      );

      if (response.data.success) {
        if (
          customerId &&
          Number(customerId) === Number(process.env.REACT_APP_CUSTOMER_ID)
        ) {
          navigate(`/redemption/thank-you`);
          return;
        } else {
          if (redirectToLinkedin) {
            window.location.href = "https://www.linkedin.com/company/swageazy";
          } else {
            navigate(`/redemption/thank-you`);
          }
        }
      }
    } catch (error) {}
  };

  function handleSkipForNow() {
    setModalShown(true);
    openThankYouOrLinkedinPage();
  }

  return (
    <div className="feedback-page-container">
      {loading ? (
        <div className="loading-indicator-admin"> </div>
      ) : (
        <>
          <div
            className="feedback-content"
            style={{
              padding: 0,
            }}
          >
            <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
              <div
                // className={
                //   customerId &&
                //   Number(customerId) ===
                //     Number(process.env.REACT_APP_CUSTOMER_ID)
                //     ? "top-margin-two light-header"
                //     : "top-margin-two header"
                // }
                className="top-margin-two header"
                style={{
                  background: redemptionData.headerColor || "#1E1665",
                }}
              >
                {redemptionData.logoImage && (
                  <div className="d-flex">
                    <GradientHeader
                      logoSrc={redemptionData.logoImage}
                      justifyContent="flex-start"
                      headerColor={redemptionData.headerColor}
                    />
                  </div>
                )}
              </div>
            </div>
            <div className="mx-auto order-confirm">
              <div
                className="row d-flex flex-column align-items-center"
                style={{
                  background: "#5945D7",
                  borderTopLeftRadius: "6px",
                  borderTopRightRadius: "6px",
                }}
              >
                {/* Top Section: Image */}
                <div className="w-100 d-flex justify-content-center mt-4 position-relative">
                  <img
                    src={congrats}
                    alt="Congrats"
                    className="img-fluid"
                    style={{ minHeight: "100px", minWidth: "100px" }}
                  />
                </div>

                {/* Bottom Section: Text */}
                <div className="text-center px-3">
                  <div className="mb-2 order-confirm-text">
                    Response Confirmed!
                  </div>
                  <div className="text-white mb-2" style={{ fontSize: "14px" }}>
                    Your response has been recorded.
                  </div>
                </div>
              </div>

              <div className="row p-4 py-0 mb-0 rounded bg-white shadow">
                <div className="mb-3 mt-3">
                  <h6 className="mb-2">Rate your experience</h6>
                  <div className="d-flex flex-wrap mx-n1">
                    {ratings.map((rating) => (
                      <div
                        key={rating.value}
                        onClick={() => setSelectedRating(rating.value)}
                        style={{
                          width: "calc(25% - 6px)",
                          margin: "3px",
                          padding: "6px 3px",
                          border: `2px solid ${
                            selectedRating === rating.value
                              ? "#6C5DD3"
                              : "#E5E5E5"
                          }`,
                          borderRadius: "6px",
                          cursor: "pointer",
                          textAlign: "center",
                          backgroundColor:
                            selectedRating === rating.value
                              ? "#F8F9FE"
                              : "white",
                        }}
                      >
                        <FontAwesomeIcon
                          icon={rating.icon}
                          style={{
                            fontSize: "20px",
                            color:
                              selectedRating === rating.value
                                ? "#6C5DD3"
                                : "#666",
                            marginBottom: "3px",
                          }}
                        />
                        <div
                          style={{
                            fontSize: "12px",
                            color:
                              selectedRating === rating.value
                                ? "#6C5DD3"
                                : "#666",
                            whiteSpace: "nowrap",
                          }}
                        >
                          {rating.label}
                        </div>
                      </div>
                    ))}
                  </div>
                </div>

                <div className="mb-4">
                  <h6 className="mb-2">Write your feedback</h6>
                  <textarea
                    className="form-control"
                    placeholder="Want to suggest anything else"
                    rows="4"
                    value={feedback}
                    onChange={(e) => setFeedback(e.target.value)}
                    style={{
                      border: "1px solid #E5E5E5",
                      borderRadius: "8px",
                      padding: "12px",
                    }}
                  />
                </div>

                <div className="btn-div buttons mb-4">
                  <div className="col-12 col-xl-6 col-md-6 col-sm-6 p-sm-0">
                    <button
                      className="border-1 bg-white p-2 px-3 rounded-pill skip"
                      style={{ color: "#3F3D56" }}
                      onClick={handleSkipForNow}
                    >
                      Skip for now
                    </button>
                  </div>
                  <div className="col-12 col-xl-6 col-md-6 col-sm-6 p-sm-0">
                    <button
                      className="border-0 p-2 px-4 rounded-pill text-white py-2 submit"
                      style={{ background: "#6455ED" }}
                      onClick={handleSubmit}
                    >
                      Submit Feedback
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* <Footer
            aboveFooterText={
              customerId &&
              Number(customerId) === Number(process.env.REACT_APP_CUSTOMER_ID)
                ? "Enjoy choosing your Diwali gift - may this add to your festive joy!"
                : "🎉 Enjoy your swag pack, and please know that you are valued and appreciated"
            }
          /> */}
          <Footer
            footerText={redemptionData.footerText}
            footerColor={redemptionData.footerColor}
            customerId={redemptionData.customerId}
          />
          <Modal
            shown={modalShown}
            center
            classNames={{
              modal: "customModal",
              modalAnimationIn: "customEnterModalAnimation",
              modalAnimationOut: "customLeaveModalAnimation",
            }}
            animationDuration={400}
          >
            <div className="successModalContainer text-center">
              <div className="confettiSvg text-center">
                <img
                  src={congrats}
                  alt="Congratulations"
                  style={{ width: "75px", height: "75px" }}
                />
              </div>
              <div className="successContent" style={{ margin: "20px 0" }}>
                <p>
                  Loved the experience? Discover how Swageazy brings it all to
                  life.
                </p>
              </div>
            </div>
          </Modal>
        </>
      )}
    </div>
  );
};
